import page3 from "./Page3.webp";
import page4 from "./Page4.webp";
import page5 from "./Page5.webp";
import page6 from "./Page6.webp";
import page7 from "./Page7.webp";

export const biophilicPages = [page3, page4, page5, page6, page7];
